{
  "countries": {
    "AW": {
      "name": "Aruba"
    },
    "AF": {
      "name": "Afghanistan",
      "nationality": "Afghanisch"
    },
    "AO": {
      "name": "Angola",
      "nationality": "Angolanisch"
    },
    "AI": {
      "name": "Anguilla"
    },
    "AX": {
      "name": "Åland-Inseln",
      "nationality": "Åland Insel"
    },
    "AL": {
      "name": "Albanien",
      "nationality": "Albanisch"
    },
    "AD": {
      "name": "Andorra",
      "nationality": "Andorranisch"
    },
    "AE": {
      "name": "Vereinigte Arabische Emirate",
      "nationality": "Vereinigte Arabische Emirate"
    },
    "AR": {
      "name": "Argentinien",
      "nationality": "Argentinisch"
    },
    "AM": {
      "name": "Armenien",
      "nationality": "Armenisch"
    },
    "AS": {
      "name": "Amerikanisch-Samoa"
    },
    "AQ": {
      "name": "Antarktis"
    },
    "TF": {
      "name": "Französische Süd- und Antarktisgebiete",
      "nationality": "Französische Süd- und Antarktisgebiete"
    },
    "AG": {
      "name": "Antigua und Barbuda",
      "nationality": "Antiguanisch"
    },
    "AU": {
      "name": "Australien",
      "nationality": "Australisch"
    },
    "AT": {
      "name": "Österreich",
      "nationality": "Österreichisch"
    },
    "AZ": {
      "name": "Aserbaidschan",
      "nationality": "Aserbaidschanisch"
    },
    "BI": {
      "name": "Burundi",
      "nationality": "Burundisch"
    },
    "BE": {
      "name": "Belgien",
      "nationality": "Belgisch"
    },
    "BJ": {
      "name": "Benin",
      "nationality": "Beninisch"
    },
    "BQ": {
      "name": "Bonaire, Sint Eustatius und Saba",
      "nationality": "Bonaire, Sint Eustatius und Saba"
    },
    "BF": {
      "name": "Burkina Faso",
      "nationality": "Burkinisch"
    },
    "BD": {
      "name": "Bangladesch",
      "nationality": "Bangladeschisch"
    },
    "BG": {
      "name": "Bulgarien",
      "nationality": "Bulgarisch"
    },
    "BH": {
      "name": "Bahrain",
      "nationality": "Bahrainisch"
    },
    "BS": {
      "name": "Bahamas",
      "nationality": "Bahamaisch"
    },
    "BA": {
      "name": "Bosnien und Herzegowina",
      "nationality": "Bosnisch"
    },
    "BL": {
      "name": "Saint-Barthélemy",
      "nationality": "St. Barthélemy"
    },
    "BY": {
      "name": "Weißrussland",
      "nationality": "Weißrussisch"
    },
    "BZ": {
      "name": "Belize",
      "nationality": "Belizisch"
    },
    "BM": {
      "name": "Bermuda",
      "nationality": "Bermudisch"
    },
    "BO": {
      "name": "Bolivien",
      "nationality": "Bolivisch"
    },
    "BR": {
      "name": "Brasilien",
      "nationality": "Brasilianisch"
    },
    "BB": {
      "name": "Barbados",
      "nationality": "Barbadisch"
    },
    "BN": {
      "name": "Brunei Darussalam",
      "nationality": "Bruneiisch"
    },
    "BT": {
      "name": "Bhutan",
      "nationality": "Bhutanisch"
    },
    "BV": {
      "name": "Bouvet-Insel",
      "nationality": "Bouvet insel"
    },
    "BW": {
      "name": "Botsuana",
      "nationality": "Botsuanisch"
    },
    "CF": {
      "name": "Zentralafrikanische Republik",
      "nationality": "Zentralafrikanisch"
    },
    "CA": {
      "name": "Kanada",
      "nationality": "Kanadisch"
    },
    "CC": {
      "name": "Kokos-(Keeling-)Inseln",
      "nationality": "Kokosinseln"
    },
    "CH": {
      "name": "Schweiz",
      "nationality": "Schweizerisch"
    },
    "CL": {
      "name": "Chile",
      "nationality": "Chilenisch"
    },
    "CN": {
      "name": "China",
      "nationality": "Chinesisch"
    },
    "CI": {
      "name": "Côte d'Ivoire",
      "nationality": "Ivorisch"
    },
    "CM": {
      "name": "Kamerun",
      "nationality": "Kamerunisch"
    },
    "CD": {
      "name": "Demokratische Republik Kongo",
      "nationality": "Kongolesisch (Demokratische Republik Kongo)"
    },
    "CG": {
      "name": "Kongo",
      "nationality": "Kongolesisch (Republik Kongo)"
    },
    "CK": {
      "name": "Cookinseln",
      "nationality": "Cookinseln"
    },
    "CO": {
      "name": "Kolumbien",
      "nationality": "Kolumbisch"
    },
    "KM": {
      "name": "Komoren",
      "nationality": "Komorisch"
    },
    "CV": {
      "name": "Cabo Verde",
      "nationality": "Kapverdisch"
    },
    "CR": {
      "name": "Costa Rica",
      "nationality": "Costa-Ricanisch"
    },
    "CU": {
      "name": "Kuba",
      "nationality": "Kubanisch"
    },
    "CW": {
      "name": "Curaçao",
      "nationality": "Curaçao"
    },
    "CX": {
      "name": "Weihnachtsinseln",
      "nationality": "Weihnachtsinsel"
    },
    "KY": {
      "name": "Cayman-Inseln",
      "nationality": "Kaimaninseln"
    },
    "CY": {
      "name": "Zypern",
      "nationality": "Zyprisch"
    },
    "CZ": {
      "name": "Tschechien",
      "nationality": "Tschechisch"
    },
    "DE": {
      "name": "Deutschland",
      "nationality": "Deutsch"
    },
    "DJ": {
      "name": "Dschibuti",
      "nationality": "Dschibutisch"
    },
    "DM": {
      "name": "Dominica",
      "nationality": "Dominicanisch"
    },
    "DK": {
      "name": "Dänemark",
      "nationality": "Dänisch"
    },
    "DO": {
      "name": "Dominikanische Republik",
      "nationality": "Dominikanisch"
    },
    "DZ": {
      "name": "Algerien",
      "nationality": "Algerisch"
    },
    "EC": {
      "name": "Ecuador",
      "nationality": "Ecuadorianisch"
    },
    "EG": {
      "name": "Ägypten",
      "nationality": "Ägyptisch"
    },
    "ER": {
      "name": "Eritrea",
      "nationality": "Eritreisch"
    },
    "EH": {
      "name": "Westsahara",
      "nationality": "Westsahara"
    },
    "ES": {
      "name": "Spanien",
      "nationality": "Spanisch"
    },
    "EE": {
      "name": "Estland",
      "nationality": "Estnisch"
    },
    "ET": {
      "name": "Äthiopien",
      "nationality": "Äthiopisch"
    },
    "FI": {
      "name": "Finnland",
      "nationality": "Finnisch"
    },
    "FJ": {
      "name": "Fidschi",
      "nationality": "Fidschianisch"
    },
    "FK": {
      "name": "Falklandinseln (Malwinen)",
      "nationality": "Falklandinseln"
    },
    "FR": {
      "name": "Frankreich",
      "nationality": "Französisch"
    },
    "FO": {
      "name": "Färöer-Inseln",
      "nationality": "Färöer"
    },
    "FM": {
      "name": "Mikronesien, Föderierte Staaten von",
      "nationality": "Mikronesisch"
    },
    "GA": {
      "name": "Gabun",
      "nationality": "Gabunisch"
    },
    "GB": {
      "name": "Vereinigtes Königreich",
      "nationality": "Britisch"
    },
    "GE": {
      "name": "Georgien",
      "nationality": "Georgisch"
    },
    "GG": {
      "name": "Guernsey",
      "nationality": "Guernsey"
    },
    "GH": {
      "name": "Ghana",
      "nationality": "Ghanaisch"
    },
    "GI": {
      "name": "Gibraltar",
      "nationality": "Gibraltar"
    },
    "GN": {
      "name": "Guinea",
      "nationality": "Äquatorial-Guineisch (Guinea)"
    },
    "GP": {
      "name": "Guadeloupe",
      "nationality": "Guadeloupe"
    },
    "GM": {
      "name": "Gambia",
      "nationality": "Gambisch"
    },
    "GW": {
      "name": "Guinea-Bissau",
      "nationality": "Guinea-Bissauisch"
    },
    "GQ": {
      "name": "Äquatorialguinea",
      "nationality": "Äquatorial-Guineisch (Äquatorialguinea)"
    },
    "GR": {
      "name": "Griechenland",
      "nationality": "Griechisch"
    },
    "GD": {
      "name": "Grenada",
      "nationality": "Grenadisch"
    },
    "GL": {
      "name": "Grönland",
      "nationality": "Grönländisch"
    },
    "GT": {
      "name": "Guatemala",
      "nationality": "Guatemaltekisch"
    },
    "GF": {
      "name": "Französisch-Guyana",
      "nationality": "Französisch-Guayana"
    },
    "GU": {
      "name": "Guam",
      "nationality": "Guamisch"
    },
    "GY": {
      "name": "Guyana",
      "nationality": "Guyanisch"
    },
    "HK": {
      "name": "Hongkong",
      "nationality": "Hongkong"
    },
    "HM": {
      "name": "Heard und McDonaldinseln",
      "nationality": "Heard und McDonaldinseln"
    },
    "HN": {
      "name": "Honduras",
      "nationality": "Honduranisch"
    },
    "HR": {
      "name": "Kroatien",
      "nationality": "Kroatisch"
    },
    "HT": {
      "name": "Haiti",
      "nationality": "Haitianisch"
    },
    "HU": {
      "name": "Ungarn",
      "nationality": "Ungarisch"
    },
    "ID": {
      "name": "Indonesien",
      "nationality": "Indonesisch"
    },
    "IM": {
      "name": "Insel Man",
      "nationality": "Man (Isle of Man)"
    },
    "IN": {
      "name": "Indien",
      "nationality": "Indisch"
    },
    "IO": {
      "name": "Britisches Territorium im Indischen Ozean",
      "nationality": "Britisches Territorium im Indischen Ozean"
    },
    "IE": {
      "name": "Irland",
      "nationality": "Irisch"
    },
    "IR": {
      "name": "Iran, Islamische Republik",
      "nationality": "Iranisch"
    },
    "IQ": {
      "name": "Irak",
      "nationality": "Irakisch"
    },
    "IS": {
      "name": "Island",
      "nationality": "Isländisch"
    },
    "IL": {
      "name": "Israel",
      "nationality": "Israelisch"
    },
    "IT": {
      "name": "Italien",
      "nationality": "Italienisch"
    },
    "JM": {
      "name": "Jamaika",
      "nationality": "Jamaikanisch"
    },
    "JE": {
      "name": "Jersey",
      "nationality": "Jersey"
    },
    "JO": {
      "name": "Jordanien",
      "nationality": "Jordanisch"
    },
    "JP": {
      "name": "Japan",
      "nationality": "Japanisch"
    },
    "KZ": {
      "name": "Kasachstan",
      "nationality": "Kasachisch"
    },
    "KE": {
      "name": "Kenia",
      "nationality": "Kenianisch"
    },
    "XK": {
      "name": "Kosovo",
      "nationality": "Kosovar"
    },
    "KG": {
      "name": "Kirgisistan",
      "nationality": "Kirgisisch"
    },
    "KH": {
      "name": "Kambodscha",
      "nationality": "Kambodschanisch"
    },
    "KI": {
      "name": "Kiribati",
      "nationality": "Kiribatisch"
    },
    "KN": {
      "name": "St. Kitts und Nevis",
      "nationality": "St. Kitts und Nevis"
    },
    "KR": {
      "name": "Korea, Republik",
      "nationality": "Südkoreanisch"
    },
    "KW": {
      "name": "Kuwait",
      "nationality": "Kuwaitisch"
    },
    "LA": {
      "name": "Laos, Demokratische Volksrepublik",
      "nationality": "Laotisch"
    },
    "LB": {
      "name": "Libanon",
      "nationality": "Libanesisch"
    },
    "LR": {
      "name": "Liberia",
      "nationality": "Liberianisch"
    },
    "LY": {
      "name": "Libyen",
      "nationality": "Libysch"
    },
    "LC": {
      "name": "St. Lucia",
      "nationality": "Lucianisch"
    },
    "LI": {
      "name": "Liechtenstein",
      "nationality": "Liechtensteinisch"
    },
    "LK": {
      "name": "Sri Lanka",
      "nationality": "Sri-Lankisch"
    },
    "LS": {
      "name": "Lesotho",
      "nationality": "Lesothisch"
    },
    "LT": {
      "name": "Litauen",
      "nationality": "Litauisch"
    },
    "LU": {
      "name": "Luxemburg",
      "nationality": "Luxemburgisch"
    },
    "LV": {
      "name": "Lettland",
      "nationality": "Lettisch"
    },
    "MO": {
      "name": "Macao",
      "nationality": "Macau"
    },
    "MF": {
      "name": "Saint Martin (Französischer Teil)",
      "nationality": "Saint-Martin"
    },
    "MA": {
      "name": "Marokko",
      "nationality": "Marokkanisch"
    },
    "MC": {
      "name": "Monaco",
      "nationality": "Monegassisch"
    },
    "MD": {
      "name": "Moldau",
      "nationality": "Moldawisch"
    },
    "MG": {
      "name": "Madagaskar",
      "nationality": "Madagassisch"
    },
    "MV": {
      "name": "Malediven",
      "nationality": "Maledivisch"
    },
    "MX": {
      "name": "Mexiko",
      "nationality": "Mexikanisch"
    },
    "MH": {
      "name": "Marshallinseln",
      "nationality": "Marshallisch"
    },
    "MK": {
      "name": "Mazedonien, ehemalige jugoslawische Republik",
      "nationality": "Mazedonisch"
    },
    "ML": {
      "name": "Mali",
      "nationality": "Malisch"
    },
    "MT": {
      "name": "Malta",
      "nationality": "Maltesisch"
    },
    "MM": {
      "name": "Myanmar",
      "nationality": "Myanmarisch"
    },
    "ME": {
      "name": "Montenegro",
      "nationality": "Montenegrinisch"
    },
    "MN": {
      "name": "Mongolei",
      "nationality": "Mongolisch"
    },
    "MP": {
      "name": "Nördliche Marianen",
      "nationality": "Nördliche Marianen"
    },
    "MZ": {
      "name": "Mosambik",
      "nationality": "Mosambikanisch"
    },
    "MR": {
      "name": "Mauretanien",
      "nationality": "Mauretanisch"
    },
    "MS": {
      "name": "Montserrat",
      "nationality": "Montserrat"
    },
    "MQ": {
      "name": "Martinique",
      "nationality": "Martinique"
    },
    "MU": {
      "name": "Mauritius",
      "nationality": "Mauritisch"
    },
    "MW": {
      "name": "Malawi",
      "nationality": "Malawisch"
    },
    "MY": {
      "name": "Malaysia",
      "nationality": "Malaysisch"
    },
    "YT": {
      "name": "Mayotte",
      "nationality": "Mayotte"
    },
    "NA": {
      "name": "Namibia",
      "nationality": "Namibisch"
    },
    "NC": {
      "name": "Neukaledonien",
      "nationality": "Neukaledonien"
    },
    "NE": {
      "name": "Niger",
      "nationality": "Nigerianisch (Niger)"
    },
    "NF": {
      "name": "Norfolkinsel",
      "nationality": "Norfolkinsel"
    },
    "NG": {
      "name": "Nigeria",
      "nationality": "Nigerianisch (Nigeria)"
    },
    "NI": {
      "name": "Nicaragua",
      "nationality": "Nicaraguanisch"
    },
    "NU": {
      "name": "Niue",
      "nationality": "Niueanisch"
    },
    "NL": {
      "name": "Niederlande",
      "nationality": "Niederländisch"
    },
    "NO": {
      "name": "Norwegen",
      "nationality": "Norwegisch"
    },
    "NP": {
      "name": "Nepal",
      "nationality": "Nepalesisch"
    },
    "NR": {
      "name": "Nauru",
      "nationality": "Nauruisch"
    },
    "NZ": {
      "name": "Neuseeland",
      "nationality": "Neuseelandneuseeländisch"
    },
    "OM": {
      "name": "Oman",
      "nationality": "Omanisch"
    },
    "PK": {
      "name": "Pakistan",
      "nationality": "Pakistanisch"
    },
    "PA": {
      "name": "Panama",
      "nationality": "Panamaisch"
    },
    "PN": {
      "name": "Pitcairn",
      "nationality": "Pitcairninseln"
    },
    "PE": {
      "name": "Peru",
      "nationality": "Peruanisch"
    },
    "PH": {
      "name": "Philippinen",
      "nationality": "Philippinsch"
    },
    "PW": {
      "name": "Palau",
      "nationality": "Palauisch"
    },
    "PG": {
      "name": "Papua-Neuguinea",
      "nationality": "Papua-Neuguienisch"
    },
    "PL": {
      "name": "Polen",
      "nationality": "Polnisch"
    },
    "PR": {
      "name": "Puerto Rico",
      "nationality": "Puerto-Ricanisch"
    },
    "KP": {
      "name": "Korea, Demokratische Volksrepublik",
      "nationality": "Nordkoreanisch"
    },
    "PT": {
      "name": "Portugal",
      "nationality": "Portugiesisch"
    },
    "PY": {
      "name": "Paraguay",
      "nationality": "Paraguayisch"
    },
    "PS": {
      "name": "Palästina, Staat",
      "nationality": "Gazastreifen"
    },
    "PF": {
      "name": "Französisch-Polynesien",
      "nationality": "Französisch-Polynesien"
    },
    "QA": {
      "name": "Katar",
      "nationality": "Katarisch"
    },
    "RE": {
      "name": "Réunion",
      "nationality": "Réunion"
    },
    "RO": {
      "name": "Rumänien",
      "nationality": "Rumänisch"
    },
    "RU": {
      "name": "Russische Föderation",
      "nationality": "Russisch"
    },
    "RW": {
      "name": "Ruanda",
      "nationality": "Ruandisch"
    },
    "SA": {
      "name": "Saudi-Arabien",
      "nationality": "Saudi-Arabisch"
    },
    "SD": {
      "name": "Sudan",
      "nationality": "Sudanesisch"
    },
    "SN": {
      "name": "Senegal",
      "nationality": "Senegalesisch"
    },
    "SG": {
      "name": "Singapur",
      "nationality": "Singapurisch"
    },
    "GS": {
      "name": "South Georgia und die Südlichen Sandwichinseln",
      "nationality": "Südgeorgien und die Südlichen Sandwichinseln"
    },
    "SH": {
      "name": "St. Helena, Ascension und Tristan da Cunha",
      "nationality": "St.Helena"
    },
    "SJ": {
      "name": "Svalbard und Jan Mayen",
      "nationality": "Jan Mayen"
    },
    "SB": {
      "name": "Salomoninseln",
      "nationality": "Salomonisch"
    },
    "SL": {
      "name": "Sierra Leone",
      "nationality": "Sierra-Leonisch"
    },
    "SV": {
      "name": "El Salvador",
      "nationality": "Salvadorianisch"
    },
    "SM": {
      "name": "San Marino",
      "nationality": "San-Marinesisch"
    },
    "SO": {
      "name": "Somalia",
      "nationality": "Somalisch"
    },
    "PM": {
      "name": "St. Pierre und Miquelon",
      "nationality": "St. Pierre und Miquelon"
    },
    "RS": {
      "name": "Serbien",
      "nationality": "Serbisch"
    },
    "SS": {
      "name": "Südsudan",
      "nationality": "Südsudanesisch"
    },
    "ST": {
      "name": "São Tomé und Príncipe",
      "nationality": "São-Toméisch"
    },
    "SR": {
      "name": "Suriname",
      "nationality": "Surinamisch"
    },
    "SK": {
      "name": "Slowakei",
      "nationality": "Slowakisch"
    },
    "SI": {
      "name": "Slowenien",
      "nationality": "Slowenisch"
    },
    "SE": {
      "name": "Schweden",
      "nationality": "Schwedisch"
    },
    "SZ": {
      "name": "Swasiland",
      "nationality": "Swasiländisch"
    },
    "SX": {
      "name": "Saint-Martin (Niederländischer Teil)",
      "nationality": "Sint Maarten"
    },
    "SC": {
      "name": "Seychellen",
      "nationality": "Seychellisch"
    },
    "SY": {
      "name": "Syrien, Arabische Republik",
      "nationality": "Syrisch"
    },
    "TC": {
      "name": "Turks- und Caicosinseln",
      "nationality": "Turks- und Caicosinseln"
    },
    "TD": {
      "name": "Tschad",
      "nationality": "Tschadisch"
    },
    "TG": {
      "name": "Togo",
      "nationality": "Togolesisch"
    },
    "TH": {
      "name": "Thailand",
      "nationality": "Thailändisch"
    },
    "TJ": {
      "name": "Tadschikistan",
      "nationality": "Tadschikisch"
    },
    "TK": {
      "name": "Tokelau",
      "nationality": "Tokelau"
    },
    "TM": {
      "name": "Turkmenistan",
      "nationality": "Turkmenisch"
    },
    "TL": {
      "name": "Timor-Leste",
      "nationality": "Timoresisch"
    },
    "TO": {
      "name": "Tonga",
      "nationality": "Tongaisch"
    },
    "TT": {
      "name": "Trinidad und Tobago",
      "nationality": "Trinidad und Tobago"
    },
    "TN": {
      "name": "Tunesien",
      "nationality": "Tunesisch"
    },
    "TR": {
      "name": "Türkei",
      "nationality": "Türkisch"
    },
    "TV": {
      "name": "Tuvalu",
      "nationality": "Tuvaluisch"
    },
    "TW": {
      "name": "Taiwan",
      "nationality": "Taiwanesisch"
    },
    "TZ": {
      "name": "Tansania",
      "nationality": "Tansanisch"
    },
    "UG": {
      "name": "Uganda",
      "nationality": "Ugandisch"
    },
    "UA": {
      "name": "Ukraine",
      "nationality": "Ukrainisch"
    },
    "UM": {
      "name": "United States Minor Outlying Islands",
      "nationality": "United States Minor Outlying Islands"
    },
    "UY": {
      "name": "Uruguay",
      "nationality": "Uruguayisch"
    },
    "US": {
      "name": "Vereinigte Staaten",
      "nationality": "Amerikanisch"
    },
    "UZ": {
      "name": "Usbekistan",
      "nationality": "Usbekisch"
    },
    "VA": {
      "name": "Heiliger Stuhl (Staat Vatikanstadt)",
      "nationality": "Vatikanisch"
    },
    "VC": {
      "name": "St. Vincent und die Grenadinen",
      "nationality": "Vincentisch"
    },
    "VE": {
      "name": "Venezuela",
      "nationality": "Venezolanisch"
    },
    "VG": {
      "name": "Britische Jungferninseln",
      "nationality": "Britische Jungferninseln"
    },
    "VI": {
      "name": "Amerikanische Jungferninseln",
      "nationality": "Amerikanische Jungferninseln"
    },
    "VN": {
      "name": "Vietnam",
      "nationality": "Vietnamesisch"
    },
    "VU": {
      "name": "Vanuatu",
      "nationality": "Vanuatisch"
    },
    "WF": {
      "name": "Wallis und Futuna",
      "nationality": "Wallis und Futuna"
    },
    "WS": {
      "name": "Samoa",
      "nationality": "Samoanisch"
    },
    "YE": {
      "name": "Jemen",
      "nationality": "Jemenitisch"
    },
    "ZA": {
      "name": "Südafrika",
      "nationality": "Südafrikanisch"
    },
    "ZM": {
      "name": "Sambia",
      "nationality": "Sambisch"
    },
    "ZW": {
      "name": "Simbabwe",
      "nationality": "Simbabwisch"
    }
  }
}
